import Flickity from 'flickity';

class PLTVersatile {
	flkty!: Flickity;

	DOM!: {
		rotator: HTMLElement | null;
	};

	constructor() {
		this.cache();
		this.initRotator();
	}

	cache() {
		this.DOM = {
			rotator: document.querySelector('.js-versatileRotator'),
		};
	}

	initRotator() {
		if (!this.DOM.rotator) return;
		this.flkty = new Flickity(this.DOM.rotator, {
			cellAlign: 'left',
			pageDots: false,
			wrapAround: true,
		});
	}
}

new PLTVersatile();
